import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { selectSettings } from '../../store/selectors/settingsSelectors';
import config from '../../config';
import { pxToRem } from '../../assets/styles/helper';

const TradingItemImageStyle = styled.img`
  width: ${({ width }) => `${width}px`};
  height: ${({ height }) => `${height}px`};
  margin-right: ${({ marginRight }) =>
    marginRight ? `${marginRight}px` : pxToRem(4)};
`;

const ProductImage = ({ productCode, width, height, marginRight }) => {
  const { RootUrl } = useSelector(selectSettings);

  const imgSource = config.algoliaSearch.imageCode
    .replace('{product_code}', productCode)
    .replace('{base_url}', RootUrl);

  return (
    <TradingItemImageStyle
      width={width}
      height={height}
      marginRight={marginRight}
      src={imgSource}
    />
  );
};

export default ProductImage;

ProductImage.propTypes = {
  productCode: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  marginRight: PropTypes.number,
};
